import {
  Box,
  Flex,
  Text,
  Button,
  VStack,
  Circle,
  Container,
  Icon,
  Input,
  useToast,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import { cpfFormatter, removeNonDigits } from "@/utils/cpfFormatter";
import { IoIosArrowForward } from "react-icons/io";
import { useUserInfo } from "@/contexts/userInfoContext";
import { phoneFormatter } from "@/utils/phoneFormatter";
import { FaWhatsapp } from "react-icons/fa";
import { useConditionalBackground } from "@/contexts/useConditionalBackground ";
import Logo from "@/components/Logo";
import { validateCPF } from "@/utils/validateCPF";
import { getSelfServiceBySlug } from "@/services/selfService.service";
import { useSlug } from "@/contexts/selfServiceSlugContext";
import { sendLeads } from "@/services/leadsSelfService.service";

export default function Instructions() {
  const { slug, slugSeller, slugSelfService } = useParams<{
    slug?: string;
    slugSeller?: string;
    slugSelfService?: string;
  }>();
  const { user, setUser } = useUserInfo();
  const { selfServiceSlug, setSelfServiceSlug } = useSlug();
  const [cpf, setCpf] = useState<string>("");
  const [isCpfValid, setIsCpfValid] = useState(true);
  const [error, setError] = useState("");

  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const toast = useToast();
  const navigate = useNavigate();
  const backgroundStyle = useConditionalBackground();
  const whatsappNumber = selfServiceSlug?.supportPhone;

  const handleSupport = () => {
    let phoneNumber = "+55" + whatsappNumber?.replace(/\D/g, "");

    const message =
      "Olá, estou tentando antecipar meu saque aniversário e tenho uma dúvida!";
    const whatsappURL = `https://wa.me/${phoneNumber}/?text=${encodeURIComponent(
      message
    )}`;

    window.open(whatsappURL, "_blank");
  };

  const handleSimualtion = async () => {
    setUser({
      name: name,
      document: removeNonDigits(cpf),
      phone: removeNonDigits(phone),
    });

    if (
      removeNonDigits(cpf).length === 11 &&
      name.length > 2 &&
      removeNonDigits(phone).length === 11
    ) {
      sendLeads({
        name: name,
        phone: removeNonDigits(phone),
        document: removeNonDigits(cpf),
        selfServiceId: selfServiceSlug?.id,
        sellerId: selfServiceSlug?.User?.id,
      });
      navigate(
        slugSelfService
          ? `/${slug}/${slugSeller}/${slugSelfService}/tutorial`
          : slugSeller
          ? `/${slug}/${slugSeller}/tutorial`
          : `/${slug}/tutorial`
      );
    } else {
      toast({
        title: "Dados inválidos",
        description: "Preencha todos os dados.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handlePhoneChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const maskedValue = phoneFormatter(e.target.value);
      setPhone(maskedValue);
    },
    []
  );

  const handleNameChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setName(e.target.value);
    },
    []
  );

  async function fetchSlug() {
    try {
      const dataSlug = await getSelfServiceBySlug(
        slug,
        slugSeller,
        slugSelfService
      );
      if (!dataSlug) {
        navigate("/404");
      }
      setSelfServiceSlug(dataSlug);
    } catch (error: any) {
      if (error.status === 404) {
        navigate("/404");
      }
      console.error(error);
    }
  }

  useEffect(() => {
    setName(user.name ?? "");
    setCpf(cpfFormatter(user.document));
    setPhone(phoneFormatter(user.phone));
    fetchSlug();
  }, []);

  return (
    <Flex
      {...backgroundStyle}
      minH="100vh"
      color="white"
      flexDirection="column"
      justifyContent="space-between"
    >
      <Container minH="100vh" h="100%" p={0}>
        <Flex minH="45vh" flexDirection="column" gap={5} p={5}>
          <Flex justify="flex-end" align="center">
            {/* <Button
              onClick={handleBack}
              aria-label="Voltar"
              variant="link"
              color="white"
              _hover={{ color: "gray.200" }}
            >
              <ChevronLeftIcon boxSize={6} />
            </Button> */}
            <Button
              onClick={handleSupport}
              size="sm"
              variant="outline"
              leftIcon={<FaWhatsapp size={16} />}
              color="primary"
              bg="white"
              _hover={{ bg: "white", color: "primary" }}
            >
              Suporte
            </Button>
          </Flex>
          <Flex w={"100%"} justifyContent="center" mt={-14}>
            <Logo
              w="50px"
              variant="secondary"
              alt="Logo"
              right={{ base: "47%", md: "50%" }}
            />
          </Flex>
          <Box>
            <Text fontSize="2xl" fontWeight="bold">
              Antecipação do
              <br />
              Saque Aniversário FGTS
            </Text>
          </Box>

          <Flex fontSize="md" flexDirection="column" gap={3}>
            <Flex gap={3} borderRadius="md" flex={1} align="center">
              <Circle
                marginLeft="0"
                size={12}
                bg="white"
                color="primary"
                fontWeight="bold"
              >
                1
              </Circle>
              <Text>Dinheiro rápido a juros baixos</Text>
            </Flex>

            <Flex gap={3} borderRadius="md" flex={1} align="center">
              <Circle
                marginLeft="0"
                size={12}
                bg="white"
                color="primary"
                fontWeight="bold"
              >
                2
              </Circle>

              <Text>
                Contratação <strong>100%</strong> online.
              </Text>
            </Flex>

            <Flex gap={3} borderRadius="md" flex={1} align="center">
              <Circle
                marginLeft="0"
                size={12}
                bg="white"
                color="primary"
                fontWeight="bold"
              >
                3
              </Circle>
              <Text>
                Dinheiro na conta <strong>em alguns minutos.</strong>
                <br />
              </Text>
            </Flex>
          </Flex>
        </Flex>

        <Flex justifyContent="center" mb={2}>
          <Text fontSize="xs" color="white" textAlign="center">
            Obs: Sujeito a análise do banco.
          </Text>
        </Flex>

        <Flex
          flexDirection="column"
          alignItems="start"
          color="secondary"
          bg="white"
          w="100%"
          h="100%"
          minH="55vh"
          pt={5}
          pb={0}
          px={7}
          gap={5}
          borderTopRadius={25}
        >
          <Text fontSize="2xl" alignSelf="center">
            Contratar é muito fácil!
          </Text>

          <Text fontSize="2xl" alignSelf="center">
            Para contratar, informe seu:
          </Text>

          <VStack color="gray.700" textAlign="center" align="stretch">
            <Flex alignItems="flex-start" flexDirection="column">
              <Text fontSize="xl">Nome Completo:</Text>
              <Input
                value={name}
                onChange={handleNameChange}
                placeholder="João Da Silva"
                type="text"
              ></Input>
            </Flex>
            <Flex alignItems="flex-start" flexDirection="column" mt={2}>
              <Text fontSize="xl">CPF:</Text>
              <Input
                value={cpf}
                placeholder="___.___.___-__"
                type="tel"
                onChange={(e) => {
                  const formattedCpf = cpfFormatter(e.target.value);
                  setCpf(formattedCpf);
                  setError("");
                }}
                onBlur={() => {
                  if (cpf.length === 14 && !validateCPF(cpf)) {
                    setError("CPF inválido");
                    setIsCpfValid(false);
                  } else {
                    setError("");
                    setIsCpfValid(true);
                  }
                }}
              />
              {error && (
                <Text color="red.500" fontSize="sm" mt={1}>
                  {error}
                </Text>
              )}
            </Flex>
            <Flex alignItems="flex-start" flexDirection="column" mt={2}>
              <Text fontSize="xl">Telefone Celular:</Text>
              <Input
                value={phone}
                onChange={handlePhoneChange}
                placeholder="(00) 00000-0000"
                type="tel"
              ></Input>
            </Flex>
          </VStack>
          <Flex alignSelf="flex-end" gap="4" mt={10}>
            <Button
              colorScheme="primary"
              size="md"
              _hover={{ bg: "gray.100" }}
              alignSelf="flex-end"
              mb={4}
              onClick={handleSimualtion}
              isDisabled={!isCpfValid || cpf.length !== 14}
            >
              Prosseguir
              <Icon as={IoIosArrowForward} boxSize={4} ml={2} color="white" />
            </Button>
          </Flex>
        </Flex>
      </Container>
    </Flex>
  );
}
